import React from "react"
import * as Yup from "yup"
import { Box, VStack } from "@chakra-ui/react"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import TextField from "components/ReactHookForm/TextField"
import SwitchField from "components/ReactHookForm/SwitchField"
import { Website } from "sharedTypes"
import * as api from "api/websites"
import { updateWebsite } from "context/actions"
import { useQueryClient } from "react-query"
import { AgendaSettingsFormValues } from "pages/EventShow/WebPage/types"

interface Props {
  eventId: string
  website: Website
  onClose: () => void
  onHide: () => void
  onChange?: (values: AgendaSettingsFormValues) => void
}

const AgendaSettings = ({
  eventId, website, onClose, onHide, onChange,
}: Props) => {
  const queryClient = useQueryClient()

  const onSubmit = (values: AgendaSettingsFormValues): void => {
    api.putWebsite(eventId, values)
      .then(({ data }) => {
        updateWebsite(queryClient, eventId, data)
        onHide()
      })
  }

  const validationSchema = Yup.object().shape({
    agendaEnabled: Yup.boolean(),
    agendaHeader: Yup.string(),
  })

  return (
    <ModalForm
      title="Agenda Settings"
      size="lg"
      onClose={onClose}
      initialValues={{
        agendaEnabled: website.agendaEnabled ?? true,
        agendaHeader: website.agendaHeader || "Agenda",
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      disableSubmitWhenNotDirty
      onChange={onChange}
    >
      {({ control }) => (
        <VStack spacing={4} align="stretch">
          <SwitchField
            name="agendaEnabled"
            control={control}
            label="Show Agenda"
            fontSize="2xl"
            fontWeight="normal"
          />

          <Box>
            <TextField
              name="agendaHeader"
              control={control}
              label="Header"
              variant="outline"
              vertical
              mb={0}
            />
          </Box>
        </VStack>
      )}
    </ModalForm>
  )
}

export default AgendaSettings
